import { render, staticRenderFns } from "./NotAllowedView.vue?vue&type=template&id=39d46cf8&scoped=true"
import script from "./NotAllowedView.vue?vue&type=script&lang=js"
export * from "./NotAllowedView.vue?vue&type=script&lang=js"
import style0 from "./NotAllowedView.vue?vue&type=style&index=0&id=39d46cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d46cf8",
  null
  
)

export default component.exports